import {TimelineFrameDataContext} from "../../../../TimelineFramePage";
import {createContext, useContext} from "react";
import {mapVisibleQuestionnaires} from "../../../../../../utils/TimelineUtils";
import {isEmpty} from "lodash";

export const TimelineFrameQuestionnaireContext = createContext(null);
export const TimelineFrameContentQuestionnairesWrapper = ({children}) => {
    const { data } = useContext(TimelineFrameDataContext);
    const visibleQuestionnaires = mapVisibleQuestionnaires(data);

    if(isEmpty(visibleQuestionnaires)) {
        return null;
    }

    return (
        <TimelineFrameQuestionnaireContext.Provider value={visibleQuestionnaires}>
            {children}
        </TimelineFrameQuestionnaireContext.Provider>
    )
}